<div class="skeleton-image"
     [class.small]="size === 'small'"
     [class.medium]="size === 'medium'"
     [class.large]="size === 'large'"
     [style.width]="!isResponsive ? width : null"
     [style.height]="!isResponsive ? height : null">
  <div class="skeleton-shimmer"></div>
</div>